// genderValidation.ts

const validateGender = (gender: string | undefined, genders: string[]): boolean => {
    return !!gender && genders.includes(gender);
};

export default validateGender;
